import { render, staticRenderFns } from "./WaitingProfileDetails.vue?vue&type=template&id=065c77d1&scoped=true"
import script from "./WaitingProfileDetails.vue?vue&type=script&lang=js"
export * from "./WaitingProfileDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065c77d1",
  null
  
)

export default component.exports